export default "__VITE_ASSET__CYh5xRai__"